import { createBackdrop, removeBackdrop } from './backdrop.js';

const initCustomSelects = ()=> {

    const closeSelect = (customSelect) => {
        if (!customSelect) return;

        const dropdown = customSelect.querySelector('.select-items-dropdown');
        const selected = customSelect.querySelector('.select-selected');

        if (dropdown) dropdown.classList.remove('show');

        setTimeout(() => {
            customSelect.classList.remove('select--open');
        }, 200); // синхронно с fade

        if (selected) {
            selected.classList.remove('select-arrow-active');
        }

        removeBackdrop('backdrop--select');
    };

    const createCustomSelect = ( customSelect = null) => {
        // console.log('selectCustomInit');

        let x, i, j, l, ll, a, aa, aaa, b, bb, c;
        /* Look for any elements with the class "form__item_select": */

        if (customSelect) {
            x = [customSelect];
        } else {
            x = document.querySelectorAll(".form__item_select");
        }

        l = x.length;

        for (i = 0; i < l; i++) {

            const wrapper = x[i];
            const selElmnt = wrapper.querySelector('select');

            wrapper.setAttribute('data-name', selElmnt.getAttribute('name'));

            const isMultiple = selElmnt.hasAttribute('multiple');

            ll = selElmnt.length;
            /* For each element, create a new DIV that will act as the selected item: */

            a = document.createElement("div");
            a.setAttribute("class", "select-selected");


            const labelText = selElmnt.dataset.label;

            if (labelText && !wrapper.querySelector('.select-label')) {
                // гарантируем id у select
                if (!selElmnt.id) {
                    selElmnt.id = `select-${Math.random().toString(36).slice(2, 9)}`;
                }

                const label = document.createElement('label');
                label.className = 'select-label';
                label.setAttribute('for', selElmnt.id);
                label.textContent = labelText;

                label.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // если select disabled — не открываем
                    if (selElmnt.disabled) return;

                    const selected = wrapper.querySelector('.select-selected');
                    if (selected) selected.click();
                });

                wrapper.appendChild(label);
            }

            // если select disabled
            if (selElmnt.hasAttribute('disabled')) {
                a.classList.add('select-selected--disabled');
            }

            aa = document.createElement("div");
            aa.setAttribute("class", "select-selected-inner");

            aaa = document.createElement("div");
            aaa.setAttribute("class", "select-selected-content");

            const placeholderText = selElmnt.dataset.placeholder || null;

            const selectedOption = Array.from(selElmnt.options)
                .find(opt => opt.hasAttribute('selected'));

            if (selectedOption) {
                a.classList.add('select-selected-custom');
                aaa.innerHTML =
                    selectedOption.dataset.content ||
                    selectedOption.innerHTML;

                wrapper.classList.add('value-selected');
            } else if (placeholderText) {
                selElmnt.selectedIndex = -1;
                a.classList.add('select-selected-custom');
                aaa.innerHTML = placeholderText;
            } else if (selElmnt.options.length) {
                const firstOption = selElmnt.options[0];
                a.classList.add('select-selected-custom');
                aaa.innerHTML =
                    firstOption.dataset.content ||
                    firstOption.innerHTML;

                wrapper.classList.add('value-selected');
            }

            aa.appendChild(aaa);
            a.appendChild(aa);
            wrapper.appendChild(a);
            /* For each element, create a new DIV that will contain the option list: */

            bb = document.createElement("div");
            bb.setAttribute("class", "select-items-dropdown fade");

            const inner = document.createElement("div");
            inner.setAttribute("class", "select-items-inner");

            b = document.createElement("div");
            b.setAttribute("class", "select-items");

            if (selElmnt.hasAttribute('data-search')) {
                let searchBlock = document.createElement('div');
                searchBlock.classList.add('select-search');

                const searchInput = document.createElement('input');
                searchInput.setAttribute('type', 'text');
                searchInput.setAttribute('name', selElmnt.getAttribute('name') + '_search');
                searchInput.setAttribute('placeholder', selElmnt.dataset.search || '');

                searchBlock.appendChild(searchInput);
                bb.appendChild(searchBlock);

                const noItems = document.createElement('div');
                noItems.innerHTML = selElmnt.dataset.notFound || '';
                noItems.classList.add('select-no-results');

                bb.appendChild(noItems);

                searchInput.addEventListener('input', function(e) {
                    const value = e.target.value.toLowerCase();
                    const items = this.closest('.form__item_select').querySelectorAll('.select-item');

                    items.forEach(item => {
                        const itemText = item.textContent.toLowerCase();
                        if (itemText.indexOf(value) > -1) {
                            item.classList.remove('select-item--hidden');
                        } else {
                            item.classList.add('select-item--hidden');
                        }
                    });

                    const shownItems = this.closest('.form__item_select').querySelectorAll('.select-item:not(.select-item--hidden)');
                    if (shownItems.length === 0) {
                        noItems.classList.add('show')
                    } else {
                        noItems.classList.remove('show')
                    }

                });
            }

            inner.appendChild(b);
            bb.appendChild(inner);

            if (selElmnt.hasAttribute('data-search')) {
                j = 0
            } else {
                j = 1
            }

            // создаём элементы списка
            for (j = 0; j < ll; j++) {
                c = document.createElement("div");
                c.classList.add('select-item');

                selElmnt.options[j].hasAttribute('selected') ? c.classList.add('same-as-selected') : null;
                selElmnt.options[j].hasAttribute('disabled') ? c.classList.add('select-item--disabled') : null;

                const attributes = selElmnt.options[j].attributes;
                [].forEach.call(attributes, function(attr) {
                    if (attr.name === 'data-content') {
                        c.classList.add('select-item-custom');
                        c.innerHTML = attr.value;
                    } else {
                        if (attr.name !== 'selected') {
                            c.innerHTML = selElmnt.options[j].innerHTML;
                            if (attr.name === 'value') {
                                c.setAttribute('data-value', attr.value);
                            } else {
                                c.setAttribute(attr.name, attr.value);
                            }
                        }
                    }
                });

                c.addEventListener("click", function(e) {
                    e.stopPropagation();
                    e.preventDefault();

                    const custom = this.closest('.form__item_select');
                    const s = custom.getElementsByTagName("select")[0];
                    const h = custom.querySelector(".select-selected-content");
                    const clickedValue = this.getAttribute('data-value');

                    // найти индекс соответствующей option в оригинальном select
                    let matchingIndex = -1;
                    for (let ii = 0; ii < s.length; ii++) {
                        if (s.options[ii].value === clickedValue
                            || s.options[ii].innerHTML === this.innerHTML
                            || s.options[ii].dataset.content === this.innerHTML) {
                            matchingIndex = ii;
                            break;
                        }
                    }
                    if (matchingIndex === -1) return;

                    if (s.hasAttribute('multiple')) {
                        // toggle для multiple
                        const opt = s.options[matchingIndex];
                        opt.selected = !opt.selected;

                        if (opt.selected) {
                            this.classList.add("same-as-selected");
                        } else {
                            this.classList.remove("same-as-selected");
                        }

                        // обновляем шапку с выбранными опциями
                        if (typeof updateMultipleHeader === 'function') {
                            updateMultipleHeader(h, s);
                        }

                        // не закрываем dropdown для множественного выбора
                    } else {
                        // single-select
                        for (let i2 = 0; i2 < s.length; i2++) {
                            if (s.options[i2].innerHTML === this.innerHTML || s.options[i2].dataset.content === this.innerHTML) {
                                s.selectedIndex = i2;
                                h.innerHTML = this.innerHTML;
                                const y = this.parentNode.querySelectorAll(".same-as-selected");
                                for (let k = 0; k < y.length; k++) {
                                    y[k].classList.remove("same-as-selected");
                                }
                                this.classList.add("same-as-selected");
                                break;
                            }
                        }
                        custom.classList.add('value-selected');
                        if (!placeholderText || s.selectedIndex !== -1) {
                            custom.classList.add('value-selected');
                        }
                        closeSelect(custom);
                    }

                    // общий dispatch change
                    s.dispatchEvent(new Event('change'));
                });

                b.appendChild(c);
            }


            // Mobile close button
            const closeWrapper = document.createElement('div');
            closeWrapper.className =
                'sticky z-2 bg-white bottom-0 flex lg:hidden justify-center py-2 px-6 ' +
                'shadow-[inset_0_1px_0_rgba(20,25,22,0.25)]';

            const closeBtn = document.createElement('button');
            closeBtn.type = 'button';
            closeBtn.className = 'w-10 h-10 p-0 border-none cursor-pointer flex-none flex justify-center items-center';
            closeBtn.setAttribute('data-close-select', '');

            // если используешь svg напрямую
            closeBtn.innerHTML = `<svg fill="none" width="32px" height="32px" viewBox="0 0 32 32"><path fill="CurrentColor" d="m8.53 24.41-.94-.94L15.06 16 7.59 8.53l.94-.94L16 15.06l7.47-7.47.94.94L16.94 16l7.47 7.47-.94.94L16 16.94z"/></svg>`;

            closeWrapper.appendChild(closeBtn);
            bb.appendChild(closeWrapper);

            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const customSelect = closeBtn.closest('.form__item_select');
                closeSelect(customSelect);
            });


            wrapper.appendChild(bb);

            a.addEventListener("click", function(e) {
                e.stopPropagation();

                const customSelect = this.closest('.form__item_select');
                const dropdown = customSelect.querySelector('.select-items-dropdown');

                if (customSelect.classList.contains('select--open')) {
                    closeSelect(customSelect);
                } else {
                    closeAllSelect(); // закроем другие
                    customSelect.classList.add('select--open');
                    // setTimeout(() => dropdown.classList.add('show'), 10);
                    requestAnimationFrame(() => dropdown.classList.add('show'));

                    createBackdrop(
                        customSelect,
                        () => closeSelect(customSelect),
                        'backdrop--select fade'
                    );
                }
            });

        }

        function updateMultipleHeader(container, selectEl) {
            while (container.firstChild) container.removeChild(container.firstChild);

            const selectedLabels = [];
            for (let oi = 1; oi < selectEl.options.length; oi++) { // <-- начиная с 1
                if (selectEl.options[oi].selected) {
                    const label = selectEl.options[oi].dataset.content || selectEl.options[oi].innerHTML;
                    selectedLabels.push(label);
                }
            }

            if (selectedLabels.length === 0) {
                // отображаем placeholder
                const ph = document.createElement('span');
                ph.classList.add('select-placeholder');
                ph.innerHTML = selectEl.options[0].dataset.content || selectEl.options[0].innerHTML || '';
                container.appendChild(ph);
            } else {
                // показываем до 3 выбранных, остальные как +N
                const maxShow = 3;
                const toShow = selectedLabels.slice(0, maxShow);
                const text = toShow.join(', ') + (selectedLabels.length > maxShow ? ` +${selectedLabels.length - maxShow}` : '');
                container.innerHTML = text;
            }
        }

        function closeAllSelect(currentSelectedEl) {
            /* A function that will close all select boxes in the document,
            except the current select box: */
            const customSelects = document.querySelectorAll('.form__item_select');

            customSelects.forEach(cs => {
                const selected = cs.querySelector('.select-selected');
                const dropdown = cs.querySelector('.select-items-dropdown');

                // если это текущий селект — не трогаем
                if (currentSelectedEl && selected === currentSelectedEl) return;

                cs.classList.remove('select--open');
                if (dropdown) dropdown.classList.remove('show');
                if (selected) selected.classList.remove('select-arrow-active');
            });

            removeBackdrop('backdrop--select');

            // let x, y, i, xl, yl, arrNo = [];
            // // x = document.querySelectorAll(".select-items-dropdown");
            // y = document.querySelectorAll(".select-selected");
            // xl = x.length;
            // yl = y.length;
            // for (i = 0; i < yl; i++) {
            //     if (elmnt === y[i]) {
            //         arrNo.push(i)
            //     } else {
            //         y[i].classList.remove("select-arrow-active");
            //     }
            // }
            // for (i = 0; i < xl; i++) {
            //     if (arrNo.indexOf(i) === -1) {
            //         wrapper.classList.add("select-hide");
            //     }
            // }
        }

        /* If the user clicks anywhere outside the select box,
        then close all select boxes: */
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.form__item_select')) {
                closeAllSelect();
            }
        });
    }

    const resetCustomSelects = (selectList = null, scope = document) => {
        let selects = [];

        if (Array.isArray(selectList) && selectList.length) {
            // сбрасываем только указанные селекты
            selects = selectList
                .map(name => scope.querySelector(`[name="${name}"]`))
                .filter(Boolean)
                .map(select => select.closest('.form__item_select'))
                .filter(Boolean);
        } else {
            // ⬅️ если массив не передан — сбрасываем ВСЕ
            selects = Array.from(
                scope.querySelectorAll('.form__item_select')
            );
        }

        selects.forEach(customSelect => {
            const selected = customSelect.querySelector('.select-selected');
            const items = customSelect.querySelector('.select-items-dropdown');

            customSelect.classList.remove('value-selected');

            if (selected) selected.remove();
            if (items) items.remove();

            createCustomSelect(customSelect);
        });
    };

    const setCustomSelectValue = (select, value) => {
        // select : original <select> DOM element
        // value : for single -> number/string value; for multiple -> array of values
        const customSelect = select.closest('.form__item_select');
        const options = customSelect.querySelectorAll('.select-item');

        if (select.hasAttribute('multiple')) {
            // accept array
            if (!Array.isArray(value)) value = [value];
            // clear all first
            for (let i = 0; i < select.options.length; i++) {
                select.options[i].selected = false;
            }
            value.forEach(val => {
                for (let i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === String(val) || parseInt(select.options[i].value) === parseInt(val)) {
                        select.options[i].selected = true;
                        break;
                    }
                }
            });
            // refresh header summary
            const content = customSelect.querySelector('.select-selected-content');
            if (content) {
                // reuse updateMultipleHeader
                // updateMultipleHeader(content, select);
                // also update item classes in dropdown
                options.forEach(opt => {
                    const v = opt.getAttribute('data-value');
                    const found = Array.from(value).some(val => String(val) === String(v));
                    if (found) {
                        opt.classList.add('same-as-selected');
                    } else {
                        opt.classList.remove('same-as-selected');
                    }
                });
            }
        } else {
            // single
            select.value = value;
            // find corresponding option and simulate click on its custom item
            options.forEach((option) => {
                if (option.dataset.value === String(value) || option.textContent === String(value)) {
                    option.click();
                }
            });
        }

        // fire change
        select.dispatchEvent(new Event('change'));
    };


    return {
        createCustomSelect,
        resetCustomSelects,
        setCustomSelectValue
    }

}

export default initCustomSelects;
